import {AppPresupuestosService} from '../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../core/services/app-info.service';
import {EnumNombresGrids, EnumOtrosNombresGrids} from '../../core/models/enum/enum-nombres-grids';
import {ClsUtil} from '../../util/cls-util';
import {
  DmSecundarioComponent
} from '../../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {
  DmCatalogosGralsComponent
} from '../../componentes/00-contenedores/docker-manager/dmcatalogosgrals/dm-catalogos-grals.component';
import {EnumMenuOpIDPpto, EnumMenuOpIDPrincipal} from '../../core/models/enum/enum-menus-opciones';
import {ClsConfigGrids, ClsConfiguracionGrid} from "../../core/models/cls-configuracion-grid";
import {inject} from "@angular/core";

export class ClsObjConfiguracionGrid {
  // PROPS
  public ClsConfigGrids: ClsConfigGrids[] = [];
  public ClsConfigGrid: ClsConfiguracionGrid[] = [];
  public columnsEditables = [
    { grid: EnumNombresGrids.Partidas, colsEditables: ['Partida', 'PartidaAuxiliar', 'DescripcionPartidaLarga', 'DescripcionPartida', 'MetrosCuadrados'],
      colsHidden: []},
    { grid: EnumNombresGrids.Conceptos, colsEditables: ['Marca', 'Renglon', 'Codigo', 'CodigoAuxiliar', 'DescripcionLarga', 'Descripcion', 'Unidad', 'Cantidad', 'CostoMoneda1', 'CostoMoneda2', 'PrecioMoneda1', 'PrecioMoneda2', 'TipoInsumo'],
      colsHidden: []},
    { grid: EnumNombresGrids.Matrices, colsEditables: ['Renglon', 'Codigo', 'DescripcionLarga', 'Descripcion', 'TipoInsumo', 'Unidad', 'CostoMoneda1', 'CostoMoneda2', 'TipoOperacion', 'Volumen', 'ImporteMoneda1', 'ImporteMoneda2', 'Expresion'],
      colsHidden: []},
    { grid: EnumNombresGrids.ExpIns, colsEditables: ['Marca', 'Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad', 'Tipo', 'CostoMoneda1', 'CostoMoneda2', 'Familia', 'Proveedor', 'InsumoIntegrado', 'EsPorcentaje', 'TipoPorcentaje', 'Referencia', 'UrlContenido'],
      colsHidden: ['Marca', 'Url', 'Participa', 'Expins', 'ImporteMoneda1', 'ImporteMoneda2', 'PendienteAnalizar', 'Referencia', 'UrlContenido']},
    { grid: EnumNombresGrids.PptoCompleto, colsEditables: ['Marca', 'CodigoAuxiliar', 'Cantidad', 'CostoMoneda1', 'CostoMoneda2', 'IndirectoEspecial'],
      colsHidden: []},
    { grid: EnumNombresGrids.Materiales, colsEditables: ['Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad', 'CostoLab', 'Fletes', 'Maniobra', 'Almacenaje', 'Derechos', 'Mermas', 'Costo', 'Fecha'],
      colsHidden: ['Descripcion']},
    { grid: EnumNombresGrids.Maquinaria, colsEditables: ['Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad', 'CostoMoneda1', 'CostoMoneda2', 'VidaEconomicaLlantas', 'VidaEconomicaPiezas', 'Potencia', 'FactorOperacion', 'FactorCombustible', 'FactorOtrasFuentes', 'FactorLubricante', 'CapacidadCarter', 'HrsCambio', 'VidaEconomicaHrs', 'HorasXAnio', 'ValorRescate', 'TasaInteres1', 'TasaInteres2', 'PrimaAnualSeguros', 'FactorMantenimiento', 'Marca', 'Modelo', 'NumeroSerie', 'Capacidad', 'Ubicacion', 'VidaUtil', 'Propietario'],
      colsHidden: ['Descripcion', 'CostoMoneda2', 'TasaInteres2']},
    { grid: EnumNombresGrids.MO, colsEditables: ['Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad', 'SalarioBase', 'FactorSalarioIntegrado', 'Fasar', 'SalarioIntegrado', 'SalarioReal', 'Viaticos', 'AlimentacionHospedaje', 'GastosSepelio', 'OtrasPrestaciones', 'CostoTotal', 'TipoFasar'],
      colsHidden: ['Descripcion']},
    { grid: EnumNombresGrids.Calendario, colsEditables: ['Calendario', 'Descripcion', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo', 'Predeterminado'],
      colsHidden: []
    },
    {
      grid: EnumNombresGrids.Fechas, colsEditables: ['FechaNoLaborable', 'Descripcion'],
      colsHidden: []
    }
  ];

  private infApp = inject(AppInfoService);
  constructor() {}

  public saveGridState(gridName: string, isInitialize: boolean, stateDefault: any, state: any, adjustText: boolean): void {
    this.ClsConfigGrids = [];
    this.ClsConfigGrid = [];
    const loggedInUserEmail = this.infApp.usuarioLogeado.email;
    if (!ClsUtil.esNulo(state)) {
      state = typeof (state) === 'string' ? JSON.parse(state) : state;
    }
    if (!ClsUtil.esNulo(stateDefault)) {
      stateDefault = typeof (stateDefault) === 'string' ? JSON.parse(stateDefault) : stateDefault;
    }
    const newItem: ClsConfiguracionGrid = { nombreGrid: gridName, ajustar: adjustText, columns: state };
    const defaultItem: ClsConfiguracionGrid = { nombreGrid: gridName, ajustar: false, columns: stateDefault };
    const isOldConfigurationsNull = ClsUtil.esNulo(window.localStorage.getItem(EnumOtrosNombresGrids.JSONGrids));

    if (!isOldConfigurationsNull) {
      this.ClsConfigGrids = JSON.parse(window.localStorage.getItem(EnumOtrosNombresGrids.JSONGrids));
      const loggedInUserIndex = this.ClsConfigGrids.findIndex(e => e.usuario === loggedInUserEmail);

      if (loggedInUserIndex !== -1) {
        this.ClsConfigGrids.forEach(e => {
          if (!isInitialize) {
            if (e.usuario === loggedInUserEmail) {
              this.replaceGrid(gridName, e.configGrids, newItem);
            }
          } else {
            if (e.usuario === EnumOtrosNombresGrids.UserDefault) {
              this.replaceGrid(gridName, e.configGrids, defaultItem);
            }
          }
        });
      } else {
        if (!isInitialize) {
          const newItem: ClsConfigGrids = {
            usuario: loggedInUserEmail,
            configGrids: [{nombreGrid: gridName, ajustar: adjustText, columns: state}]
          };
          this.ClsConfigGrids.push(newItem);
        } else {
          const defaultUserIndex = this.ClsConfigGrids.findIndex(e => e.usuario === EnumOtrosNombresGrids.UserDefault);

          if (defaultUserIndex === -1) {
            const defaultItem: ClsConfigGrids = {
              usuario: EnumOtrosNombresGrids.UserDefault,
              configGrids: [{nombreGrid: gridName, ajustar: false, columns: stateDefault}]
            };
            this.ClsConfigGrids.push(defaultItem);
          } else {
            this.ClsConfigGrids.forEach(e => {
              if (!isInitialize) {
                if (e.usuario === loggedInUserEmail) {
                  this.replaceGrid(gridName, e.configGrids, newItem);
                }
              } else {
                if (e.usuario === EnumOtrosNombresGrids.UserDefault) {
                  this.replaceGrid(gridName, e.configGrids, defaultItem);
                }
              }
            });
          }
        }
      }
    } else {
      if (!isInitialize) {
        const newItem: ClsConfigGrids = {
          usuario: loggedInUserEmail,
          configGrids: [{nombreGrid: gridName, ajustar: false, columns: state}]
        };
        this.ClsConfigGrids.push(newItem);
      } else {
        const defaultItem: ClsConfigGrids = {
          usuario: EnumOtrosNombresGrids.UserDefault,
          configGrids: [{nombreGrid: gridName, ajustar: false, columns: stateDefault}]
        };
        this.ClsConfigGrids.push(defaultItem);
      }
    }
    window.localStorage.setItem(EnumOtrosNombresGrids.JSONGrids, JSON.stringify(this.ClsConfigGrids));
  }

  public replaceGrid(gridName: any, configGrids: any, item: any) {
    const idx = configGrids.findIndex(x => x.nombreGrid === gridName);
    idx === -1 ? configGrids.splice(0, 0, item) : configGrids.splice(idx, 1, item);
  }

  public initGridState(gridName: any) {
    this.ClsConfigGrids = [];
    const state = window.localStorage.getItem(EnumOtrosNombresGrids.JSONGrids);
    const user = this.infApp.usuarioLogeado.email;
    let stateDefault = undefined;
    let ajustar = false;
    this.ClsConfigGrids = JSON.parse(state);
    const existeGrid = this.ClsConfigGrids.find(e => e.usuario === user);
    if (!ClsUtil.esNulo(existeGrid)) { // el usuarioLogeado existe
      this.ClsConfigGrids.forEach(e => {
        // revisar si existe el grid dentro del userLogeado en configuracionGrids
        if (e.usuario === user) {
          e.configGrids.forEach(x => {
            if (x.nombreGrid === gridName) {
              stateDefault = x.columns;
              ajustar = x.ajustar;
            }
          });
        }
      });
      if (!ClsUtil.esNulo(stateDefault)) {
        return [stateDefault, ajustar];
      }
    }
    return [stateDefault, ajustar];
  }

  public restoreGrid(gridName: any) {
    try {
      this.ClsConfigGrid = [];
      const user = this.infApp.usuarioLogeado.email;
      let stateDefault = undefined;
      let ajustar = false;
      const oldConfiguracionGrids = window.localStorage.getItem(EnumOtrosNombresGrids.JSONGrids);
      if (!ClsUtil.esNulo(oldConfiguracionGrids)) { // json exists in storage
        this.ClsConfigGrids = JSON.parse(oldConfiguracionGrids);
        // seteamos el state a default al grid
        this.ClsConfigGrids.forEach(e => {
          if (e.usuario === EnumOtrosNombresGrids.UserDefault) {
            e.configGrids.forEach(x => {
              if (x.nombreGrid === gridName) {
                stateDefault = x.columns;
                ajustar = x.ajustar;
              }
            });
          }
        });
        // borramos el grid del storage
        const existeUser = this.ClsConfigGrids.find(e => e.usuario === user);
        if (!ClsUtil.esNulo(existeUser)) {
          // borramos el grid actual del storage
          this.ClsConfigGrids.forEach(e => {
            if (e.usuario === user) {
              // revisar si queda sin grids el user
              const idx = e.configGrids.findIndex(x => x.nombreGrid === gridName);
              // -1 no existe != si existe
              if (idx !== -1) {
                if (e.configGrids.length === 1) {
                  // borramos el todo el user con el unico grid
                  const index = this.ClsConfigGrids.findIndex(x => x.usuario === user);
                  this.ClsConfigGrids.splice(index, 1);
                } else {
                  e.configGrids.splice(idx, 1);
                }
              }
            }
          });
          window.localStorage.setItem(EnumOtrosNombresGrids.JSONGrids, JSON.stringify(this.ClsConfigGrids));
        }
        return [stateDefault, ajustar];
      } else { // json not exists in storage
        // console.log('Storage limpio, obtener el state de BD o de otro lado...');
        return [stateDefault, ajustar];
      }
    } catch (e) {
      throw e.message;
    }
  }

  public restoreAllGrids(infSis: AppPresupuestosService) {
    let dmSecundario: DmSecundarioComponent;
    let dmCatalogosGnral: DmCatalogosGralsComponent;
    dmSecundario = infSis.dmPrincipal.dmSecundarioPptoActivo;
    dmCatalogosGnral = infSis.dmPrincipal.dmCatalogosGrals;

    this.deleteStorage();
    // PPTO
    if (!ClsUtil.esNulo(dmSecundario)) {
      if (!ClsUtil.esNulo(dmSecundario.PptoCompleto)) {
        dmSecundario.PptoCompleto.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmSecundario.Ppto.partidaComponent)) {
        dmSecundario.Ppto.partidaComponent.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmSecundario.Ppto.conceptosComponent)) {
        dmSecundario.Ppto.conceptosComponent.restoreGrid();
        dmSecundario.Ppto.ExpInsumoAcoplado.restoreGrid(1);
      }
      if (!ClsUtil.esNulo(dmSecundario.MActivo)) {
        dmSecundario.MActivo.restoreGrid();
        dmSecundario.MActivo.ExpInsumoAcoplado.restoreGrid(2);
      }
      if (!ClsUtil.esNulo(dmSecundario.ExpInsumo)) {
        if (!ClsUtil.esNulo(dmSecundario.ExpInsumo.ExpInsumoAcoplado)) {
          dmSecundario.ExpInsumo.ExpInsumoAcoplado.restoreGrid(0);
        }
      }
    }
    // CATALOGOS
    if (!ClsUtil.esNulo(dmCatalogosGnral)) {
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosCiudad)) {
        dmCatalogosGnral.CatalogosCiudad.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosCli)) {
        dmCatalogosGnral.CatalogosCli.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosEmpresa)) {
        dmCatalogosGnral.CatalogosEmpresa.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosEdo)) {
        dmCatalogosGnral.CatalogosEdo.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosFamilia)) {
        dmCatalogosGnral.CatalogosFamilia.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosProv)) {
        dmCatalogosGnral.CatalogosProv.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosResp)) {
        dmCatalogosGnral.CatalogosResp.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosTipIns)) {
        dmCatalogosGnral.CatalogosTipIns.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosTipLic)) {
        dmCatalogosGnral.CatalogosTipLic.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosUnidad)) {
        dmCatalogosGnral.CatalogosUnidad.restoreGrid();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosVendedor)) {
        dmCatalogosGnral.CatalogosVendedor.restoreGrid();
      }
    }
  }

  public deleteStorage() {
    try {
      this.ClsConfigGrid = [];
      const user = this.infApp.usuarioLogeado.email;
      const oldConfiguracionGrids = window.localStorage.getItem(EnumOtrosNombresGrids.JSONGrids);
      if (!ClsUtil.esNulo(oldConfiguracionGrids)) {
        this.ClsConfigGrids = JSON.parse(oldConfiguracionGrids);
        // borramos todos los grids del usuario del storage
        const index = this.ClsConfigGrids.findIndex(e => e.usuario === user);
        if (index !== -1) {
          this.ClsConfigGrids.splice(index, 1);
          window.localStorage.setItem(EnumOtrosNombresGrids.JSONGrids, JSON.stringify(this.ClsConfigGrids));
        }
      }
    } catch (e) {
      throw e.message;
    }
  }

  // public deleteEditable(state: any){
  //   const aux = JSON.parse(state);
  //   // aux.columns.forEach(e => delete e.editable);
  //   return aux;
  // }
  /**
   *
   * @param data - Array de columnas del grid con sus propiedades (size, field, header, pinned, width, etc)
   * @param editable - Define si las columnas son editables
   * @param grid - Nombre del grid (EnumNombresGrids)
   * @description - Cambia la propiedad 'Editable' de las columnas definidas
   * @return data - Retorna el array de columnas
   */
  public cambiarColumnasEditables(data?: any, editable?: boolean, grid?: string) {
    data = typeof(data) === 'string' ? JSON.parse(data) : data;
    this.columnsEditables.forEach(x => {
      if (x.grid === grid) {
        x.colsEditables.forEach(xx => {
          const col = data.columns.find(z => z.field === xx);
          if (!ClsUtil.esNulo(col)) {
            data.columns.forEach(y => {
              if (y.field === col.field) {
                y.editable = editable;
              }
            });
          }
        });
      }
    });
    return data;
  }
  /**
   *
   * @param data - Array de columnas del grid con sus propiedades (size, field, header, pinned, width, etc)
   * @param hidden - Define si las columnas son visibles
   * @param grid - Nombre del grid (EnumNombresGrids)
   * @return data - Retorna el array de columnas
   */
  public cambiarColumnasOcultas(data?: any, hidden?: boolean, grid?: string) {
    data = typeof(data) === 'string' ? JSON.parse(data) : data;
    this.columnsEditables.forEach(x => {
      if (x.grid === grid) {
        x.colsHidden.forEach(xx => {
          const col = data.columns.find(z => z.field === xx);
          if (!ClsUtil.esNulo(col)) {
            data.columns.forEach(y => {
              if (y.field === col.field) {
                y.hidden = hidden;
              }
            });
          }
        });
      }
    });
    return data;
  }

  public clearSortGrids(infSis: AppPresupuestosService, sourcePane: any) {
    let dmSecundario: DmSecundarioComponent;
    let dmCatalogosGnral: DmCatalogosGralsComponent;

    dmSecundario = infSis.dmPrincipal.dmSecundarioPptoActivo;
    dmCatalogosGnral = infSis.dmPrincipal.dmCatalogosGrals;

    // CatpptoGrals
    switch (sourcePane.contentId) {
      case EnumMenuOpIDPrincipal.PptoActivo:
        // PPTO
        dmSecundario.PptoCompleto.clearProps();
        dmSecundario.Ppto.clearProps();
        dmSecundario.Ppto.partidaComponent.clearProps();
        dmSecundario.Ppto.conceptosComponent.clearProps();
        dmSecundario.Ppto.ExpInsumoAcoplado.clearProps();
        dmSecundario.MActivo.clearProps();
        dmSecundario.MActivo.ExpInsumoAcoplado.clearProps();
        dmSecundario.ExpInsumo.ExpInsumoAcoplado.clearProps();
        // CATALOGOS
        dmCatalogosGnral.CatalogosCiudad.clearProps();
        dmCatalogosGnral.CatalogosCli.clearProps();
        dmCatalogosGnral.CatalogosEmpresa.clearProps();
        dmCatalogosGnral.CatalogosEdo.clearProps();
        dmCatalogosGnral.CatalogosFamilia.clearProps();
        dmCatalogosGnral.CatalogosProv.clearProps();
        dmCatalogosGnral.CatalogosResp.clearProps();
        dmCatalogosGnral.CatalogosTipIns.clearProps();
        dmCatalogosGnral.CatalogosTipLic.clearProps();
        dmCatalogosGnral.CatalogosUnidad.clearProps();
        dmCatalogosGnral.CatalogosVendedor.clearProps();
        dmCatalogosGnral.CatalogosRegiones.clearProps();
        break;
      case EnumMenuOpIDPpto.MA:
        dmSecundario.MActivo.clearProps();
        break;
      // case EnumMenuOpIDPpto.MM:
      //   dmSecundario.MMaestro.clearProps();
      //   break;
      case EnumMenuOpIDPrincipal.Catalogos:
        dmCatalogosGnral.CatalogosCiudad.clearProps();
        dmCatalogosGnral.CatalogosCli.clearProps();
        dmCatalogosGnral.CatalogosEmpresa.clearProps();
        dmCatalogosGnral.CatalogosEdo.clearProps();
        dmCatalogosGnral.CatalogosFamilia.clearProps();
        dmCatalogosGnral.CatalogosProv.clearProps();
        dmCatalogosGnral.CatalogosResp.clearProps();
        dmCatalogosGnral.CatalogosTipIns.clearProps();
        dmCatalogosGnral.CatalogosTipLic.clearProps();
        dmCatalogosGnral.CatalogosUnidad.clearProps();
        dmCatalogosGnral.CatalogosVendedor.clearProps();
        dmCatalogosGnral.CatalogosRegiones.clearProps();
        break;
      case EnumMenuOpIDPpto.CatalogosExpIns:
        dmSecundario.ExpInsumo.ExpInsumoAcoplado.clearProps();
        dmSecundario.ExpInsumo.clearProps();
        break;
      case EnumMenuOpIDPpto.ConsultasPptpComp:
        dmSecundario.PptoCompleto.clearProps();
        break;
      case EnumMenuOpIDPpto.ConsultasBusquedaGral:
        infSis.dmPrincipal.BusquedaGral.clearProps();
        break;
    }
  }

  public clearSortGridsCats(infSis: AppPresupuestosService, sourcePane: any ) {
    let dmCatalogosGnral: DmCatalogosGralsComponent;
    dmCatalogosGnral = infSis.dmPrincipal.dmCatalogosGrals;
    switch (sourcePane.contentId) {
      case EnumMenuOpIDPrincipal.CatalogosCiudad:
        dmCatalogosGnral.CatalogosCiudad.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosCli:
        dmCatalogosGnral.CatalogosCli.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosEmpresa:
        dmCatalogosGnral.CatalogosEmpresa.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosEdo:
        dmCatalogosGnral.CatalogosEdo.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosFamilia:
        dmCatalogosGnral.CatalogosFamilia.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosProv:
        dmCatalogosGnral.CatalogosProv.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosResp:
        dmCatalogosGnral.CatalogosResp.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosTipIns:
        dmCatalogosGnral.CatalogosTipIns.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosTipLic:
        dmCatalogosGnral.CatalogosTipLic.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosUnidad:
        dmCatalogosGnral.CatalogosUnidad.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosVendedor:
        dmCatalogosGnral.CatalogosVendedor.clearProps();
        break;
      case EnumMenuOpIDPrincipal.CatalogosRegiones:
        dmCatalogosGnral.CatalogosRegiones.clearProps();
        break;
    }
  }
  public manageProps(data: any, grid: EnumNombresGrids, hidden: boolean, editable?: boolean): any {
    switch (grid) {
      case EnumNombresGrids.ExpIns:
        data = this.cambiarColumnasEditables(data, editable, EnumNombresGrids.ExpIns);
        break;
      case EnumNombresGrids.ExpInsMatriz:
      case EnumNombresGrids.ExpInsPpto:
        data = this.cambiarColumnasOcultas(data, hidden, EnumNombresGrids.ExpIns);
        data = this.cambiarColumnasEditables(data, false, EnumNombresGrids.ExpIns);
        break;
    }
    return data;
  }
}
